import 'react';
import { BsLayoutTextWindowReverse } from '@react-icons/all-files/bs/BsLayoutTextWindowReverse';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { getDisallowedAncestors } from '../../utils/ancestors.js';
import { jsx } from '@emotion/react';
import 'qs';
import 'query-string';
import { StickyTab as StickyTab$1 } from './StickyTab.js';

var StickyTab = decorateComponent(StickyTab$1, 'block', {
  id: 'stickyTab',
  label: '스티키 탭',
  defaultProps: {},
  allowedChildren: ['stickyTabItem'],
  disallowedAncestors: getDisallowedAncestors(['sticky-tab']),
  renderIcon: function renderIcon() {
    return jsx(BsLayoutTextWindowReverse, null);
  }
});

export { StickyTab as default };
//# sourceMappingURL=index.js.map
